import './bootstrap';
import '@fontsource-variable/plus-jakarta-sans';
import '../css/app.css';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import '../css/sincos-tippy-theme.css';
import 'gridstack/dist/gridstack.css';
import 'gridstack/dist/gridstack.js';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
import mitt from 'mitt';
import i18n from './Utils/i18n.js';
import ClickOutside from '@/Directives/ClickOutside.js';
import Tippy from '@/Directives/Tippy.js';
import * as Sentry from '@sentry/vue';
import PrimeVue from 'primevue/config';
import { popstateGuard } from '@/Composables/useUnsavedChanges.js';

const emitter = mitt();
const pinia = createPinia();
import 'tippy.js/animations/shift-toward.css';

// Must be registered before createInertiaApp() so it fires before Inertia's
// own popstate handler — used by useUnsavedChanges to intercept back/forward.
window.addEventListener('popstate', popstateGuard);

createInertiaApp({
    title: title => `${title}`,
    resolve: name => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const vueApp = createApp({ render: () => h(App, props) })
            .provide('emitter', emitter)
            .use(plugin)
            .use(i18n)
            .use(ZiggyVue)
            .use(pinia)
            .use(PrimeVue, {
                unstyled: true
            })
            .directive('click-outside', ClickOutside)
            .directive('tippy', Tippy);

        window.is_production = props.initialPage.props.isProduction;
        if (props.initialPage.props.isProduction) {
            const sentryTags = props.initialPage.props.sentryTags;

            Sentry.init({
                app: vueApp,
                release: sentryTags.git_tag,
                sendDefaultPii: true,
                dsn: 'https://e3e0b47fc4339e1a381ff2240e44fab5@o4509360427827200.ingest.de.sentry.io/4509360938025040',
                integrations: [
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false
                    })
                ],
                replaysSessionSampleRate: 0,
                replaysOnErrorSampleRate: 1.0,
                beforeSend(event) {
                    event.tags = { ...event.tags, ...sentryTags };
                    return event;
                }
            });
        }

        vueApp.mount(el);
    },
    progress: {
        color: '#75c044',
        showSpinner: true
    }
});
